/**
 * @desc: - 面板- 公告modal
 * @author: vico
 */
import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as commonAction from '../../../actions/commonAction'

class Bulletins extends React.Component {
  constructor(props) {
    super(props);
    this.getDetail = this.getDetail.bind(this);
    this.state = {
      currentId: null,
      curtentPage: 1,
      parentId: null,
      page: 1,
    }
  }

  componentDidMount() {
    this.props.$$COMMON.getBulletins(1);

  }

  componentDidUpdate() {
    let _cur = this.props.__COMMON.toJS().bulletins.count;
    let _page = this.state.curtentPage;
    this.setState({ page: Math.ceil(_cur / 10) });
  }

  componentWillMount() {
    let _cur = this.props.__COMMON.toJS().bulletins.list;
    // 达福公告文本
    this.bulletins = {
      count: 11,
      list: [
        {
          created_at: "2019.05.23",
          id: 11,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "重庆时时彩撤单",
          content: `<p>尊敬的客户：</p>
<p style="text-indent: 30px; padding: 6px 0;">您好！</p>
<p style="text-indent: 30px; padding: 6px 0;">由于重庆时时彩官网第56、61期未开奖，导致平台未能开出有效号码，平台将第20190523056期、第20190523061期进行撤单操作，由此带来的不便我们深感抱歉，敬请谅解！ 感谢您一如既往对我们的理解和支持！</p>
<p>官方运营团队</p>
<p>2019年05月23日</p>`
        },
        {
          created_at: "2019.05.22",
          id: 10,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "重庆时时彩撤单＆停售公告",
          content: `<p>尊敬的客户：</p>
<p style="text-indent: 30px; padding: 6px 0;">您好！</p>
<p style="text-indent: 30px; padding: 6px 0;">由于重庆时时彩官网长时间未开奖，导致平台未能开出有效号码，平台将从第20190522001期至20190522016期进行撤单操作，目前相关彩种暂停销售，由此带来的不便我们深感抱歉，敬请谅解！ 感谢您一如既往对我们的理解和支持！</p>
<p>官方运营团队</p>
<p>2019年05月22日</p>`
        },
        {
          created_at: "2019.05.18",
          id: 9,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "【通知】央行维护通知",
          content: `<p>尊敬的用户：</p>
<p style="text-indent: 30px; padding: 6px 0;">您好！</p>
<p style="text-indent: 30px; padding: 6px 0;">央行计划于2019年5月19日(周日) 00：00至06：00进行银行系统维护，维护期间平台将关闭前台建行、工行充提渠道，给您带来不便，敬请谅解！</p>
<p style="text-indent: 30px; padding: 6px 0;">感谢您一如既往对我们的理解和支持！</p>
<p>官方运营团队</p>
<p>2019年05月18日</p>`
        },
        {
          created_at: "2019.04.23",
          id: 8,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "【维护】在线客服临时维护",
          content: `<p>亲爱的彩民：</p>
<p style="text-indent: 30px; padding: 6px 0;">您好，目前平台在线客服临时维护，维护完成时间待定，给大家带来不便敬请谅解，感谢各位彩民朋友的支持。</p>
<p>官方运营团队</p>
<p>2019年04月23日</p>`
        },
        {
          created_at: "2019.04.17",
          id: 7,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "【声明】平台杜绝索取用户密码",
          content: `<p>尊敬的用户：</p>
<p style="text-indent: 30px; padding: 6px 0;">如果您在访问在线客服等情况下，对方向您索取您在平台的登录密码、资金密码等，请您务必不要提供，平台从未向用户索取这些资料；</p>
<p style="text-indent: 30px; padding: 6px 0;">涉及到银行卡解绑、解锁、密码重置时会需要您提供有效身份信息核实；</p>
<p style="text-indent: 30px; padding: 6px 0;">感谢您的信任和支持。</p>
<p>官方运营团队</p>
<p>2019年04月17日</p>`
        },
        {
          created_at: "2019.03.10",
          id: 6,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "3月10日凌晨停机维护公告",
          content: `<p>尊敬的用户：</p>
<p style="text-indent: 30px; padding: 6px 0;">为了改善我们的服务质量，提升您的游戏体验，我们将在北京时间2019年3月10日周日凌晨3点30分进行停机维护操作，届时平台的所有功能都将暂时停止，以下是停机维护详情：</p>
<p style="text-indent: 30px; padding: 6px 0;">停机维护预计开始时间：2019-03-10 03:30</p>
<p style="text-indent: 30px; padding: 6px 0;">停机维护预计结束时间：2019-03-10 05:30</p>
<p style="text-indent: 30px; padding: 6px 0;">停机维护开始后，访问平台官网将提示平台目前正在维护中，所有登录、充值、提款、活动等功能都将关闭，所有的彩种都将停售，待停机维护结束后会恢复正常</p>
<p style="text-indent: 30px; padding: 6px 0;">如停机维护无法在预计的时间内完成，我们会另行公告进行通知，非常感谢您的支持与理解，由此带来的不便我们深感抱歉，敬请谅解！</p>
<p>达福娱乐</p>
<p>2019年03月10日</p>`
        },
        {
          created_at: "2019.02.11",
          id: 5,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "2019年春节彩票开市公告",
          content: `<p>尊敬的用户：</p>
<p style="text-indent: 30px; padding: 6px 0;">目前新春佳节已悄然临近尾声，春节彩票休市已结束，休市期间停售彩种已可正常进行投注，感谢您对我们一如既往的理解与支持，祝您在新的一年，手气长虹，赢个痛快！
</p>
<p>达福娱乐</p>
<p>2019年02月11日</p>`
        },
        {
          created_at: "2018.12.11",
          id: 1,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "12月12日凌晨停机维护公告",
          content: `<p>尊敬的用户：</p>
<p style="text-indent: 30px; padding: 6px 0;">为了改善我们的服务质量，提升您的游戏体验，我们将在2018年12月12日周三凌晨3时进行停机维护操作，届时平台的所有功能都将暂时停止，以下是停机维护详情：</p>
<p style="text-indent: 30px; padding: 6px 0;">停机维护预计开始时间：2018-12-12 03:00</p>
<p style="text-indent: 30px; padding: 6px 0;">停机维护预计结束时间：2018-12-12 06:00</p>
<p style="text-indent: 30px; padding: 6px 0;">停机维护开始后，访问平台官网将提示平台目前正在维护中，所有登录、充值、提款等功能都将关闭，所有的彩种都将停售，待停机维护结束后会恢复正常。 </p>
<p style="text-indent: 30px; padding: 6px 0;">如停机维护无法在预计的时间内完成，我们会另行公告进行通知，非常感谢您的支持与理解，由此带来的不便我们深感抱歉，敬请谅解！</p>
<p>达福娱乐</p>
<p>2018年12月11日</p>`
        },
        {
          created_at: "2018.12.11",
          id: 4,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "达福娱乐特别说明",
          content: `<p style="padding: 3px 0;">（1）会员下注均以下注成功之注单为有效，投注完成后，请核对是否下注成功；</p>
<p style="padding: 3px 0;">（2）若遇不可抗拒之情事造成损失，例：骇客侵入、网络不稳或传输中断...等，将依本平台发布公告为主；</p>
<p style="padding: 3px 0;">（3）为杜绝洗钱和盗刷他人银行卡的套利不法行为，会员在充值后必须完成充值金额20％的流水，方可出款；</p>
<p style="padding: 3px 0;">（4）平台充值、提款时间均为24小时；</p>
<p style="padding: 3px 0;">（5）平台除了网站提供的线上客服以外，绝无QQ或其它联系方式，客服亦不会私下给汇款帐号，请当心此种诈骗方式，若对平台有任何疑问或反馈请多利用本平台24小时线上客服；</p>
<p style="padding: 3px 0;">（6）平台禁止恶意对打、套取红利等套利行为一经发现，公司保留收回红利及红利所产生之盈利的权利。若本公司发现会员以不正当手法或透过平台漏洞隐瞒不报等进行投注，造成有损害公司利益的情事发生，本公司有权取消该类注单及其盈利，并停用该会员帐号；</p>
<p style="padding: 3px 0;">（7）请会员定时修改帐户密码，定时清理电脑和手机以免发生中毒而被盗号。</p>
<p>达福娱乐</p>
<p>2018/12/11</p>`
        },
        {
          created_at: "2018.11.17",
          id: 2,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "达福娱乐充值提醒",
          content: `<p>尊敬的用户：</p>
<p style="text-indent: 30px; padding: 6px 0;">欢迎来到达福娱乐，本平台目前支持网银快充、支付宝转账等多个主流支付渠道，请您在游戏过程中务必使用平台提供的官方正规渠道进行充值，避免其他渠道充值导致的诈骗情况发生。</p>
<p style="text-indent: 30px; padding: 6px 0;">针对不同的充值渠道平台有不同的充值要求，例如支付宝转账渠道需要您完整正确填写充值附言，并填写最新的银行卡信息等，同时需要在转账过程中选择2小时内到账，如出现未按照各类要求进行充值导致充值延迟到账甚至不到账的情况，平台将不承担任何责任。</p>
<p style="text-indent: 30px; padding: 6px 0;">达福娱乐致力为广大用户打造S级客户服务、S级用户体验、S级游戏玩法、S级公平公正的4S级超一流平台而不懈努力，如您在游戏过程中遇到任何困难和阻碍请第一时间与我们的在线客服取得联系，我们将第一时间为您解决所有问题，祝您手气长虹！</p>
<p>达福娱乐</p>
<p>2018/11/17</p>`
        },
        {
          created_at: "2018.10.30",
          id: 3,
          is_read: true,
          is_recommended: false,
          is_top: true,
          title: "全新彩种上线通知",
          content: `<p>尊敬的用户：</p>
<p style="text-indent: 30px; padding: 6px 0;">为了回报广大用户长久以来对平台的支持与热爱，达福娱乐推出全新彩种印尼分分彩，该彩种拥有开奖频率高，玩法丰富全面等游戏特色。全新的彩种，全新的玩法，等你一起来挑战！</p>
<p>达福娱乐</p>
<p>2018/10/30</p>`
        }
      ]
    };
  }

  //设置默认值
  componentWillReceiveProps(nextProps) {
    //如果有传值 就使用传值的ID 显示相应的详情
    if (nextProps.notice) {
      this.setState({ parentId: nextProps.notice.id });
      if (nextProps.notice.id != this.state.parentId) {
        this.setState({ currentId: nextProps.notice.id });
        this.props.$$COMMON.getBulletinDetail(nextProps.notice.id);
        return;
      }
    }

    if (this.state.currentId) {
      return
    }
    if (nextProps.__COMMON.toJS().bulletins.list.length === 0) {
      return
    }
    let _id = nextProps.__COMMON.toJS().bulletins.list[0].id;
    if (window.vers === 'df') {
      this.setState({
        currentId: this.bulletins.list[0].id,
      });
    } else {
      this.setState({
        currentId: _id,
      });
    }
    this.props.$$COMMON.getBulletinDetail(_id);
  }

  // 公告翻页
  changePage(pageNo) {
    this.setState({ curtentPage: pageNo, currentId: null });
    this.props.$$COMMON.getBulletins(pageNo);
  }

  // 公告详情
  getDetail(bulletin) {
    this.setState({
      currentId: bulletin.id,
      content: bulletin.content
    })
    if (bulletin.content) {
      return
    }
    ;
    this.props.$$COMMON.getBulletinDetail(bulletin.id);

  }

  // 首页
  firstPage() {
    this.setState({ curtentPage: 1, currentId: null })
  }

  //上一页
  prevPage() {
    let _page = this.state.curtentPage - 1;
    if (_page < 1) {
      _page = 1
    }
    this.setState({ curtentPage: _page, currentId: null });
    this.changePage(_page)
  }

  //下一页
  nextPage() {
    let _tools = this.state.page;
    let _page = this.state.curtentPage + 1;
    if (_page > _tools) {
      _page = _tools
    }
    this.setState({ curtentPage: _page, currentId: null });
    this.changePage(_page)
  }

  // 最后一页
  lastPage() {
    let _page = this.state.page;
    this.setState({ curtentPage: _page, currentId: null });
    this.changePage(_page)
  }

  render() {
    let bulletins;
    if (window.vers === 'df') {
      bulletins = this.bulletins;
    } else {
      bulletins = this.props.__COMMON.toJS().bulletins;
    }
    const list = bulletins.list;
    const pageList = Math.ceil(bulletins.count / 10);
    let curPage = this.state.curtentPage;
    let arr = [];
    for (var i = 0; i < pageList; i++) {
      if (curPage - 3 < i && i < curPage + 3) {
        arr.push(i + 1)
      }
    }
    return (
      <div>
        {
          bulletins.list && bulletins.list.length > 0 ?
            <div>
              <div className="help_notice_r">
                <h2><span></span>系统公告</h2>
                <div className="notice_sidebar_box">
                  {/*小导航  className="li_avtie"*/}
                  <ul id="newsList">
                    {
                      list.map((item, index) => {
                        return <li key={index}
                          className={this.state.currentId == item.id ? 'li_avtie' : ''}
                          onClick={this.getDetail.bind(this, item)}
                        ><font className="text">{item.title}</font><span className="st">{item.created_at}</span>
                        </li>
                      })
                    }
                  </ul>
                  <div className="newsPages-box">
                    <a href="javascript:;" className="first page" onClick={this.changePage.bind(this, 1)}></a>
                    <a href="javascript:;" className="prev page" onClick={this.prevPage.bind(this)}></a>
                    {
                      arr.map((item, index) => {
                        return <a key={index} className={item == curPage ? 'cur page' : 'page'}
                          onClick={this.changePage.bind(this, item)}>{item}</a>
                      })
                    }
                    <a href="javascript:;" className="last page" onClick={this.lastPage.bind(this)}></a>
                    <a href="javascript:;" className="next page" onClick={this.nextPage.bind(this)}></a>
                  </div>
                </div>
              </div>
              <div className="help_notice_l">
                <h3 className="title">{this.state.currentId ? _.find(bulletins.list, { id: this.state.currentId }).title : null}</h3>
                <div className="detail">
                  <p dangerouslySetInnerHTML={{ __html: this.state.currentId ? _.find(bulletins.list, { id: this.state.currentId }).content : null }}></p>
                </div>
              </div>
            </div>
            : null
        }
      </div>
    )
  }
}

reactMixin(Bulletins.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __COMMON: state.common
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$COMMON: bindActionCreators(commonAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Bulletins)